module.exports = __webpack_public_path__ + "img/document-icon-active.cc6413e1.svg";